import Button from "@mui/material/Button";
import { t } from "i18next";

type Props = {
  onClick: () => void;
};

export default function LoginButton({ onClick }: Props) {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      sx={{ mr: 1, p: { xs: 1, md: 1 } }}
    >
      {t("login")}
    </Button>
  );
}
